import * as Yup from 'yup';

export interface ForgotPasswordValues {
  email: string;
}

export const forgotPasswordSchema: Yup.SchemaOf<ForgotPasswordValues> =
  Yup.object({
    email: Yup.string().required('Email is required'),
  });
